var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36639_55412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 7.3125V9.5625",
    stroke: "#FD7900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02467 2.81143L1.83884 13.4984C1.73986 13.6694 1.68766 13.8634 1.6875 14.061C1.68734 14.2586 1.73921 14.4528 1.83791 14.6239C1.93661 14.7951 2.07865 14.9372 2.24973 15.0361C2.42082 15.1349 2.61492 15.187 2.8125 15.187H15.1842C15.3817 15.187 15.5758 15.1349 15.7469 15.0361C15.918 14.9372 16.0601 14.7951 16.1588 14.6239C16.2575 14.4528 16.3093 14.2586 16.3092 14.061C16.309 13.8634 16.2568 13.6694 16.1578 13.4984L9.97199 2.81143C9.87317 2.64069 9.73119 2.49895 9.56029 2.40041C9.3894 2.30187 9.1956 2.25 8.99833 2.25C8.80106 2.25 8.60726 2.30187 8.43637 2.40041C8.26548 2.49895 8.1235 2.64069 8.02467 2.81143Z",
    stroke: "#FD7900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5C9.62132 13.5 10.125 12.9963 10.125 12.375C10.125 11.7537 9.62132 11.25 9 11.25C8.37868 11.25 7.875 11.7537 7.875 12.375C7.875 12.9963 8.37868 13.5 9 13.5Z",
    fill: "#FD7900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36639_55412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alertIcon.706bd5b263c12193f70f3ab38282ea06.svg";
export { ForwardRef as ReactComponent };